import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import FacilitySpecialConditionsList from '../condition/FacilityList';

const HIDE_COLUMNS = ['facility'];

type FacilitySpecialConditionsTabProps = {
  facility: Facility;
};

const FacilitySpecialConditionsTab: React.FC<FacilitySpecialConditionsTabProps> = ({ facility }) => {
  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="content">
        <FacilitySpecialConditionsList
          facilityId={facility.id}
          facility={facility}
          noShow={HIDE_COLUMNS}
          showDelete
        />
      </div>
    </div>
  );
};

export default FacilitySpecialConditionsTab;
